import $ from 'jquery';

export const scrollToGo = (event) => {
  const scrollTo = $(event.currentTarget).data('scroll-to');

  $('html, body').animate(
    {
      scrollTop: $('#' + scrollTo).offset().top - 155,
    },
    500
  );
};
